<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'RequestListPagination',
  props: {
    paginationIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      updateRequestsPaginationIndex: 'requestStatus/updateRequestsPaginationIndex',
    }),
  },
  computed: {
    ...mapState({
      requests: state => state.requestStatus.requests,
      filter: state => state.requestStatus.filter,
    }),
    showPaginationButton() {
      return this.requests.items.length === 200;
    },
    showPagination() {
      return (!this.requests.loading
        && !this.filter.loading
        && !this.requests.noContent
        && this.requests.items.length !== 0);
    },
    getPaginationIndex() {
      if (this.requests.items.length === 200) {
        return `Showing page ${this.paginationIndex} with 200 results...`;
      }
      return `Showing page ${this.paginationIndex} with ${this.requests.items.length} results...`;
    },
  },
};
</script>

<template>
  <v-container>
    <v-flex v-if="showPagination" class="text-xs-center">
      <p>{{ getPaginationIndex }}</p>
      <v-btn
        v-if="showPaginationButton"
        @click="updateRequestsPaginationIndex"
        color="primary"
        outline
      >
        Show more
      </v-btn>
    </v-flex>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/requests/RequestListPagination.vue